
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters,
})
export default class CourseAccordion extends Vue {
  @Prop({ default: "" })
  private hash!: string;
  @Prop({ default: "" })
  private title!: string;

  private toggleAccordion() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.accordion.classList.toggle("active");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let panel = this.$refs.accordion.nextElementSibling as any;
    if (panel?.style.height === "auto") {
      panel.style.height = 0;
    } else {
      panel.style.height = "auto";
    }
  }
}
